"use strict";
module.exports = {
    '@lemonone/intl/deliverable:photos': 'Min {photos} photos',
    '@lemonone/intl/deliverable:internalWalkVideo': 'Walk-through video',
    '@lemonone/intl/deliverable:proWalkVideo': 'Professional walk-through video',
    '@lemonone/intl/deliverable:floorplan': 'Floor plan',
    '@lemonone/intl/deliverable:tour360': '360 tour',
    '@lemonone/intl/equipment:tiltShiftLens': 'Tilt-Shift Lens',
    '@lemonone/intl/equipment:detailLens': 'Detail Lens',
    '@lemonone/intl/equipment:extensionArmTripod': 'Tripod Arm Extension',
    '@lemonone/intl/equipment:studio': 'Studio',
    '@lemonone/intl/equipment:lightsExternalStudioLight': 'Studio Lights',
    '@lemonone/intl/equipment:lightsReflector': 'Reflector',
    '@lemonone/intl/equipment:lightsLightbox': 'Lightbox',
    '@lemonone/intl/equipment:lightsSoftbox': 'Softbox',
    '@lemonone/intl/equipment:backgroundsBackdropsColors': 'Backdrops',
    '@lemonone/intl/equipment:backgroundsPaperBackgrounds': 'Paper Backgrounds',
    '@lemonone/intl/equipment:wideAngleLens': 'Wide-Angle Lens',
    '@lemonone/intl/equipment:threesixty': '360 Kit',
    '@lemonone/intl/equipment:teleLens': 'Tele Lens',
    '@lemonone/intl/equipment:videoGimbal': 'Gimbal',
    '@lemonone/intl/equipment:videoExternalMicrophone': 'Microphone',
    '@lemonone/intl/equipment:floorplan': 'Floor plan',
    '@lemonone/intl/equipment:tiltShiftLense': 'Tilt-shift lens',
    '@lemonone/intl/equipment:camera360': '360 camera',
    '@lemonone/intl/equipment:14-24mmFullFrameOr10-16CropSensor': '14-24mm (10-16mm crop), crop sensor or full frame camera',
    '@lemonone/intl/equipment:14-20mmFullFrame': '14-20mm lens, full-frame camera',
    '@lemonone/intl/equipment:20mmFullFrame': '20mm lens, full-frame camera',
    '@lemonone/intl/equipment:12MP+Drone': '12MP+ drone',
    '@lemonone/intl/equipment:20MP+Drone': '20MP+ drone',
    '@lemonone/intl/equipment:32MP+Drone': '32MP+ drone',
    '@lemonone/intl/equipment:UAVLicense': 'UAV operator certificate/license (required)',
    '@lemonone/intl/equipment:droneWorkAccidentLiabilityInsurance': 'Work accident liability insurance (required for the drone photoshoot)',
    '@lemonone/intl/equipment:matterportCompatibleCamera': 'Matteport compatible camera https://matterport.com',
    '@lemonone/intl/equipment:ricoThetaZ1': 'RicoThetaZ1, https://matterport.com',
    '@lemonone/intl/equipment:matterportPro2OrLeicaBLK360': 'Matterport Pro2 or Leica BLK360, https://matterport.com',
    '@lemonone/intl/equipment:35mm+CropOrFullFrame': 'min. 35mm lens, crop or full frame camera',
    '@lemonone/intl/equipment:F2.8+Lens90Tripod15-30mmFullFrame': 'min. F 2.8 lens, 90 degree tripod, 15-30mm lens, full frame camera',
    '@lemonone/intl/equipment:magicPlan': '<a href="https://www.magicplan.app" target="_blank">MagicPlan App installed</a>',
    '@lemonone/intl/category:interior': 'Interior',
    '@lemonone/intl/category:exterior': 'Exterior',
    '@lemonone/intl/category:drone': 'Drone',
    '@lemonone/intl/category:threesixty': '360',
    '@lemonone/intl/category:treesixty': '360',
    '@lemonone/intl/category:food': 'Food',
    '@lemonone/intl/category:floorplan': 'Floorplan',
    '@lemonone/intl/text:date': 'Date',
    '@lemonone/intl/text:address': 'Address',
    '@lemonone/intl/text:location': 'Location',
    '@lemonone/intl/text:duration': 'Duration',
    '@lemonone/intl/text:product': 'Product',
    '@lemonone/intl/text:id': 'ID',
    '@lemonone/intl/text:orderId': 'Order ID',
    '@lemonone/intl/text:externalReference': 'Your internal ID',
    '@lemonone/intl/text:estimation': 'estimated duration',
    '@lemonone/intl/text:duration_hours': '{hours, plural, =0 {} one {{hours} hour} other {{hours} hours}} {minutes, plural, =0 {} one {{minutes} min} other {{minutes} mins}}',
    '@lemonone/intl/text:estimatedDuration': 'approx. {hours, plural, =0 {} one {{hours} hour} other {{hours} hours}} {minutes, plural, =0 {} one {{minutes} min} other {{minutes} mins}}',
    '@lemonone/intl/text:required': 'required',
    '@lemonone/intl/text:required_datetime': 'Please select a date and time',
    '@lemonone/intl/text:addressSyntax': 'Address syntax',
    '@lemonone/intl/text:streetName': 'Street name',
    '@lemonone/intl/text:houseNumber': 'House number',
    '@lemonone/intl/text:zipCode': 'Zip code',
    '@lemonone/intl/text:city': 'City',
    '@lemonone/intl/text:country': 'Country',
    '@lemonone/intl/text:termsAndConditions': 'Terms & conditions',
    '@lemonone/intl/text:termsAndConditionsUrl': 'https://www.lemonone.com/en/terms-conditions',
    '@lemonone/intl/text:privacyPolicy': 'Privacy policy',
    '@lemonone/intl/text:privacyPolicyUrl': 'https://www.lemonone.com/en/privacy-policy',
    '@lemonone/intl/text:externalId': 'reference ID',
    '@lemonone/intl/text:photoshootId': 'photoshoot ID',
    '@lemonone/intl/text:feedback': 'Feedback',
    '@lemonone/intl/text:notes': 'Notes',
    '@lemonone/intl/text:price': 'Price',
    '@lemonone/intl/text:email': 'Email'
};
//# sourceMappingURL=en.js.map